import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Reunioes } from '../../models/reunioes.model';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { FormControl, FormGroup } from '@angular/forms';
import { ReunioesService } from '../../services/reunioes.service';
import { ReunioesCombosResolver } from '../../resolver/reunioes.resolver';
import { ActivatedRoute } from '@angular/router';
import { MatPaginator, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { animate, style, transition, trigger } from '@angular/animations';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PermissionAclService } from 'src/app/shared/services/permission-acl.service';

@Component({
  selector: 'app-reunioes-list',
  templateUrl: './reunioes-list.component.html',
  styleUrls: ['./reunioes-list.component.scss'],
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(-50%)' }),
        animate('500ms ease-out', style({ opacity: 1, transform: 'translateX(0)' }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ opacity: 0, transform: 'translateX(-50%)' }))
      ])
    ])
  ]
})
export class ReunioesListComponent extends BaseFormComponent<Reunioes> implements OnInit {

  formFilter: FormGroup;
  formClone: FormGroup;
  filters: any;
  reunioesList: Reunioes[];
  reunioesSearch: Reunioes[];
  filterActive: boolean = false;
  totalRecords: number = 0;
  pageSize: number = 20;
  pageIndex: number = 0;
  idCurrentModal: string = null;
  deleteItens: boolean = false;
  listDeleteItens: number[] = [];
  canEdit:boolean = false;

  @ViewChild('paginatorFooter', { static: true, }) paginatorFooter: MatPaginator;

  constructor(
    public activatedRoute: ActivatedRoute,
    public myService: ReunioesService,
    private reunioesCombosResolver: ReunioesCombosResolver,
    private modalService: BsModalService,
    private permissionAcl: PermissionAclService,
  ) {
    super(activatedRoute); 
  }

  ngOnInit() {
    this.initForm();
    this.initLoadDataTable();
    this.changePaginatorText(this.paginatorFooter._intl);
    this.getAllPermissions();
  }

  changePaginatorText(paginator: MatPaginatorIntl){
    paginator.itemsPerPageLabel="Itens por página:";
    paginator.firstPageLabel = "Primeira página"; // |<
    paginator.nextPageLabel = "Próxima página"; // <
    paginator.previousPageLabel = "Página anterior"; // >
    paginator.lastPageLabel  = "Última página"; // >|
  }

  pageChangeEvent(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.filterData();
  }
  
  filterData(resetCount:boolean = false) {
    this.loading();
    var filter = this.getDataFilter();
    var filterData = this.reunioesList.filter(item => {
      if(filter.filter_description !== null && filter.filter_description !== undefined) {
        var desc = item.description.toLowerCase();
        var fdesc = filter.filter_description.toLowerCase() 
        if (!fdesc.split(" ").every( f => desc.includes(f) )){
          return false;
        }
      }
      if(filter.filter_accord_main_id!== null && filter.filter_accord_main_id !== undefined){
        if (item.accord_main_id != filter.filter_accord_main_id){
          return false;
        } 
      }
      if(filter.filter_agency_host!== null && filter.filter_agency_host !== undefined){
        if (item.agency_id != filter.filter_agency_host){
          return false;
        } 
      }
      if(filter.filter_agency_guest!== null && filter.filter_agency_guest !== undefined){
        if (item.agency_id != filter.filter_agency_guest){
          return false;
        } 
      }
      if(filter.filter_governance_level_id!== null && filter.filter_governance_level_id !== undefined){
        if (item.governance_level_id != filter.filter_governance_level_id){
          return false;
        } 
      }
      return true; 
    });
    if (resetCount){
      this.pageIndex = 0;
    }
    var start = this.pageIndex * this.pageSize;
    var end = start + this.pageSize;
    this.reunioesSearch = filterData.slice(start,end);
    this.totalRecords = filterData?.length ?? 0;
    this.loaded();
  }

  initForm() {
    this.formFilter = new FormGroup({
      filter_description: new FormControl(null),
      filter_accord_main_id: new FormControl(null),
      filter_agency_host: new FormControl(null),
      filter_agency_guest: new FormControl(null),
      filter_governance_level_id: new FormControl(null)
    });
    this.formClone = new FormGroup({
      dt_meet: new FormControl(null)
    });
    this.reunioesCombosResolver.resolve().subscribe({
      next: (filters) => {
        this.filters = filters;
      }
    })
  }
  cleanSearch() {
    this.formFilter.reset();
    this.filterData();
  }

  closeFilter() {
    if (this.filterActive) {
      this.filterActive = false;
    }
  }
  
  getDataFilter() {
    return Object.assign({}, this.formFilter.value);
  }
  
  initLoadDataTable() {
    this.loading();
    this.addSub(
      this.myService.findAll().subscribe({
        next: (res) => {
          this.reunioesList = res;
          this.filterData();
          this.loaded();
        },
        error: (err) => {
          this.msgError(err?.error.message);
          this.loaded();
        },
      })
    );
  }
  openModal(id: any, modalRef:BsModalRef, modal:TemplateRef<any>, classString:string = '' ) {
    this.idCurrentModal = id;
    modalRef = this.modalService.show(modal,{class:classString});
  }

  closeModal(modalRef:BsModalRef) {
    modalRef?.hide();
  }
  setDeleteItem(e){
    var item = e.target;
    if (item.checked){
      this.listDeleteItens.push(+item.id);
    }
    else{
      const index = this.listDeleteItens.indexOf(+item.id); 
      if (index > -1) {
        this.listDeleteItens.splice(index, 1);
      }
    }
  }
  clearDelete(){
    this.deleteItens = false;
    this.listDeleteItens = [];
  }
  confirmExcluir() {
    if(this.listDeleteItens.length > 0){
      this.alertConfirmation().subscribe((confirmed) => {
        if (confirmed) {
          this.excluir();
        }
      });
    }
    else{
      this.confirmation('Nenhum item selecionado','','warning', false, 'sw-system').subscribe(() => {
      });
    }
  }

  excluir(): void {
    this.loading();
    this.myService.deleteList(this.listDeleteItens).subscribe({
      next: (res) => {
        this.loaded();
        this.confirmation('Reuniões deletadas com sucesso!').subscribe(() => {
          window.location.reload();
        });
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error.message)
      }
    });
  }
  
  getAllPermissions(): void {
    this.permissionAcl.getAllPermissions().subscribe({
      next: (r) => { 
        this.canEdit = r.permissions?.reuniao_edit ?? false;
      }
    })
  }
}
